// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"ukb1PnF6"};